import { useEffect } from "react";

export const useUIEffects = (
  isSummaryDataReady: boolean,
  setShowSummaryModal: (show: boolean) => void
) => {
  // New useEffect for isSummaryDataReady
  useEffect(() => {
    if (isSummaryDataReady) {
      setShowSummaryModal(true);
    } else {
      setShowSummaryModal(false);
    }
  }, [isSummaryDataReady, setShowSummaryModal]);
};